/**
 * Types of data that can be retrieved from PWA Player
 */
enum PlayerData {
    GET_DATA = 'GET_DATA',
    APPLICATION_STATE = 'APPLICATION_STATE',
    SYSTEM_INFORMATION = 'SYSTEM_INFORMATION',
    PLATFORM_LOGS = 'PLATFORM_LOGS',
    GET_LOGS = 'GET_LOGS',
}

export default PlayerData;
